export default __webpack_public_path__ + "static/media/demo-repo-concept.146fbf1a.svg";